import { SET_RENDER_STATS } from './actionTypes';
import { isRenderStatsOpen } from './functions';
/**
 * Shows/hides the rendering measurement panel.
 *
 * Only the flag is flipped here. Mounting, measurement and teardown all follow
 * from it in RenderStatsPanel, so there is one place that can be out of step
 * with the state instead of two.
 *
 * @returns {Function}
 */
export function toggleRenderStats() {
    return (dispatch, getState) => {
        const open = !isRenderStatsOpen(getState());
        console.info(`[perf-dbg] ボタンが押されました → open=${open} にします`);
        dispatch({
            type: SET_RENDER_STATS,
            open
        });
        // 反映されたかをその場で読み返す。ここが false のままなら reducer が
        // 登録されていないか、別の store 名を見ている。
        console.info(`[perf-dbg] dispatch 後に読み返した状態 open=${isRenderStatsOpen(getState())}`);
    };
}
